const locationState = {
    location: undefined,
    requestingLocation: false
};
export default locationState;
